<template>
    <ion-card class="covid-passport" style="margin-top: 0;">
        <ion-card-header style="padding-top: 5px; padding-bottom: 10px; margin-bottom: 0;">
            <ion-card-title>
                <ion-item class="ion-no-padding ion-no-margin">
                    <h4 style="margin: 0;">{{ $t('ncrypt.covid_passport.dashboard.content_title') }}</h4>
                </ion-item>
            </ion-card-title>
        </ion-card-header>

        <ion-card-content v-if="$store.getters.authed" style="padding-top: 0;">
            <ion-grid class="ion-no-margin ion-no-padding">
                <ion-row>
                    <ion-col size-xs="12" size-sm="12" size-md="12" size-lg="12" size-xl="8"
                             style="max-width: 1000px;">
                        <ion-item
                            v-if="permissionStatus && permissionStatus.triage && ! permissionStatus.triage.has_expired"
                            class="user-bar-code"
                            lines="none"
                            style="margin-bottom: 15px;">
                            <div>
                                <div>
                                    {{ $t('ncrypt.covid_passport.dashboard.uid_code_label') }}
                                </div>

                                <div v-if="barCode">
                                    <img :src="barCode"
                                         :alt="$t('ncrypt.covid_passport.dashboard.barcode_uid_alt_text')"/>
                                </div>

                                <div style="letter-spacing: 1px;">{{ $store.getters.user.uid }}</div>
                            </div>
                        </ion-item>
                        <ion-item v-else>
                            <div>
                                <div>
                                    {{ $t('ncrypt.covid_passport.dashboard.fill_in_triage_to_unlock_barcode') }}
                                </div>

                                <ion-button @click="goToTriageForm">
                                    {{ $t('ncrypt.covid_triage.dashboard.go_to_checklist_button_text') }}
                                </ion-button>
                            </div>
                        </ion-item>
                    </ion-col>

                    <ion-col size-xs="12" size-sm="12" size-md="12" size-lg="12" size-xl="4">

                        <ion-item lines="none" style="margin-bottom: 15px;">
                            <div style="display: flex; justify-content: center; flex-wrap: wrap; width: 100%;">
                                <p class="ion-text-center" style="width: 100%;">
                                    {{ $t('ncrypt.covid_passport.dashboard.profile_picture_title') }}
                                </p>

                                <img v-if="$store.getters.user && $store.getters.user.avatar_url"
                                     class="avatar"
                                     :src="$store.getters.user.avatar_url"
                                     :alt="$t('ncrypt.covid_passport.dashboard.profile_picture_alt_text')"
                                     style="max-width: 200px;"/>

                                <div v-else style="margin-top: 20px; font-size: 80%;">
                                    <div>
                                        {{ $t('ncrypt.covid_passport.dashboard.no_profile_picture_yet') }}
                                    </div>

                                    <div style="margin-top: 15px;">
                                        <ion-button @click="$router.push({name: 'profile'}).catch(() => {});">
                                            {{ $t('ncrypt.covid_passport.dashboard.setup_profile_picture') }}
                                        </ion-button>
                                    </div>
                                </div>
                            </div>
                        </ion-item>
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col size-xs="12" size-sm="12" size-md="12" size-lg="12" size-xl="8" style="max-width: 1000px;">
                        <ion-row>
                            <ion-col size-xs="6">
                                <ion-item lines="none">
                                    {{ $t('ncrypt.name') }}
                                </ion-item>
                            </ion-col>
                            <ion-col size-xs="6">
                                <ion-item lines="none">
                                    {{ $store.getters.user.display_name }}
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col>
                                <ion-item lines="none">
                                    {{ $t('ncrypt.covid_passport.dashboard.external_identifier_label') }}
                                </ion-item>
                            </ion-col>

                            <ion-col>
                                <ion-item lines="none">{{ $store.getters.user.external_identifier }}</ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col>
                                <ion-item lines="none">
                                    {{ $t('ncrypt.covid_passport.dashboard.has_access_label') }}
                                </ion-item>
                            </ion-col>

                            <ion-col>
                                <ion-item :color="hasAccess ? 'success' : 'danger'">
                                    <div style="padding: 10px;">
                                        {{ hasAccess ? $t('ncrypt.yes') : $t('ncrypt.no') }}
                                    </div>
                                </ion-item>
                                <ion-item v-if="! hasAccess" lines="none">
                                    <ion-button @click="openNoAccessInformationHelpPage">
                                        {{ $t('ncrypt.covid_passport.dashboard.passport_red_help_button_text') }}
                                    </ion-button>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col>
                                <ion-item lines="none">
                                    {{ $t('ncrypt.covid_passport.dashboard.access_status_label') }}
                                </ion-item>
                            </ion-col>

                            <ion-col
                                v-if="permissionStatus && permissionStatus.triage && permissionStatus.triage.has_expired">
                                <ion-item lines="none">
                                    {{ $t('ncrypt.covid_passport.dashboard.access_status.expired') }}
                                </ion-item>
                            </ion-col>

                            <ion-col v-else-if="permissionStatus">
                                <ion-item lines="none" v-if="hasAccess">
                                    {{ $t('ncrypt.covid_passport.dashboard.access_status.access') }}
                                </ion-item>
                                <ion-item lines="none" v-else>
                                    {{ $t('ncrypt.covid_passport.dashboard.access_status.no_access') }}
                                </ion-item>
                            </ion-col>

                            <ion-col v-else>
                                <ion-item lines="none">
                                    {{ $t('ncrypt.covid_passport.dashboard.access_status.no_access') }}
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row v-if="permissionStatus && permissionStatus.triage">
                            <ion-col>
                                <ion-item lines="none">
                                    {{ $t('ncrypt.covid_passport.dashboard.triage_date_label') }}
                                </ion-item>
                            </ion-col>

                            <ion-col>
                                <ion-item lines="none">{{ permissionStatus.triage.completed_at_formatted }}</ion-item>
                            </ion-col>
                        </ion-row>
                    </ion-col>
                    <ion-col size-xs="12" size-sm="12" size-md="12" size-lg="12" size-xl="4">
                        <div style="display: flex; justify-content: center; flex-wrap: wrap;">
                            <img v-if="verificationQrCode"
                                 class="qr-code"
                                 :src="verificationQrCode"
                                 style="max-width: 350px;"
                                 :alt="$t('ncrypt.covid_passport.dashboard.verification_qr_code_alt_text')"/>

                            <p class="ion-text-center" style="width: 100%;">
                                {{ $t('ncrypt.covid_passport.dashboard.verification_qr_code') }}
                            </p>
                        </div>
                    </ion-col>
                </ion-row>

                <ion-row
                    v-if="canSubmitTestResult && $store.getters.authed && $store.getters.user.email.includes('@scaneurope.nl')">
                    <ion-col>
                        <h1>
                            {{ $t('ncrypt.covid_passport.dashboard.negative_ggd_test.title') }}
                        </h1>

                        <p>
                            {{ $t('ncrypt.covid_passport.dashboard.negative_ggd_test.text') }}
                        </p>

                        <ValidationObserver ref="observer">
                            <form ref="form"
                                  slot-scope="{ validate }"
                                  @submit.prevent="validate().then(submitTestResult)">
                                <ValidationProvider rules="required"
                                                    name="date"
                                                    v-slot="{ errors }">
                                    <ion-item>
                                        <ion-label position="floating">
                                            {{ $t('ncrypt.covid_passport.dashboard.negative_ggd_test.select_date') }}
                                        </ion-label>

                                        <ion-datetime year-values="2021"
                                                      display-format="DD-MM-YYYY HH:mm"
                                                      name="date"
                                                      v-model="negativeTestResultDate"
                                                      @ionChange="negativeTestResultDate = $event.detail.value"></ion-datetime>

                                        <!--                                        <ion-input inputmode="date" type="email" ref="sender"-->
                                        <!--                                                   -->
                                        <!--                                                   :color="errors.length ? 'danger' : ''"/>-->
                                    </ion-item>

                                    <ion-item v-show="errors.length"
                                              lines="none"
                                              class="ion-no-padding">
                                        <ion-note class="error"
                                                  slot="end">{{ errors[0] }}
                                        </ion-note>
                                    </ion-item>

                                    <ion-button @click="validate().then(submitTestResult)">
                                        <ion-icon ios='send'
                                                  md="send"
                                                  slot="start"/>

                                        {{ $t('ncrypt.covid_passport.dashboard.negative_ggd_test.submit_button') }}
                                    </ion-button>
                                </ValidationProvider>
                            </form>
                        </ValidationObserver>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card-content>
        <ion-card-content v-else>
            {{ $t('ncrypt.login_again') }}
        </ion-card-content>
    </ion-card>
</template>

<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate';
    import {ApiError} from "@/errors/ApiError";
    import {Notifier} from "@/services/Notifier";

    export default {
        name: "CovidPassportDashboard",
        components: {
            ValidationObserver,
            ValidationProvider,
        },
        props: {
            permissionStatus: {type: Object},
            verificationQrCode: {type: String},
            barCode: {type: String},
            canSubmitTestResult: {type: Boolean},
        },
        data() {
            return {
                negativeTestResultDate: '',
            };
        },
        computed: {
            hasAccess() {
                return this.permissionStatus && this.permissionStatus.access;
            },
        },
        methods: {
            submitTestResult() {
                console.log('negativeTestResultDate', this.negativeTestResultDate);

                this.$http
                    .post('/covid-passport/submit-negative-ggd-test-result', {
                        date: this.negativeTestResultDate,
                    })
                    .then(async ({data}) => {
                        console.log('post then data', data);

                        if (!data || !data.success) {
                            new ApiError(data);
                            return;
                        }

                        this.canSubmitTestResult = false;
                        await Notifier.showToast({
                            message: 'Uw testresultaat is ingestuurd en wordt zo snel mogelijk verwerkt.',
                        });
                    })
                    .catch(error => new ApiError(error));
            },
            openNoAccessInformationHelpPage() {
                const id = this.$i18n.locale === 'nl' ? '33' : '34';

                this.$router.push({name: 'help-item', params: {id}});
            },
            goToTriageForm() {
                this.$http
                    .post(`/covid-passport/start-triage`)
                    .then(async ({data}) => {
                        if (!data || !data.success) {
                            new ApiError(data, false);
                            return;
                        }

                        await this.$router.push({
                            name: 'covid-triage-form',
                            params: {token: data.token},
                        });
                    })
                    .catch(reason => new ApiError(reason));
            },
        },
    }
</script>

<style lang="scss">
    .covid-passport {
        ion-card-title ion-item {
            &, & h4 {
                font-size: 22px;
            }
        }

        ion-card-content ion-item {
            font-size: 18px;
            overflow: visible;
            --padding-start: 0;
            --padding-end: 0;

            @media (max-width: 1200px) {
                font-size: 16px;
            }
        }
    }

    .user-bar-code {
        margin-bottom: 10px;
        text-align: center;
    }

    @media (min-width: 1100px) {
        .user-bar-code {
            margin-bottom: 50px;
            text-align: left;
        }
    }

    img.avatar, img.qr-code {
        height: auto !important;
        align-self: flex-start;
    }
</style>
